<template>
  <div id="contenedor-licitaciones-default">
    <v-container fluid>
      <v-card
        class="mb-4"
        flat>
        <v-card-text>
          <titulo-tool-bar titulo="Licitaciones">
            <template v-slot:opciones-derecha>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click="abrirCalendario">
                    <v-icon> mdi-calendar-month </v-icon>
                  </v-btn>
                </template>
                <span> Calendario de Eventos </span>
              </v-tooltip>
              <v-tooltip left v-if="false">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    :to="{ name: 'licitacionesEstadisticas' }">
                    <v-icon> mdi-poll </v-icon>
                  </v-btn>
                </template>
                <span> Estadisticas </span>
              </v-tooltip>
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :to="{ name: 'licitacionesConfiguracionFirmas' }"
                    icon
                    v-bind="attrs"
                    v-on="on">
                    <v-icon> mdi-cog-outline </v-icon>
                  </v-btn>
                </template>
                <span> Configuración </span>
              </v-tooltip>
            </template>
          </titulo-tool-bar>
          <tool-bar
            class="mb-4"
            :listaLicitaciones="getLicitacioes"
            :filtros="filtros"
            v-on:nuevaLicitacion="registrarNuevaLicitacion"
            >
          </tool-bar>
        </v-card-text>
      </v-card>
      <v-card flat>
        <v-card-text>
          <listado :listadoLicitaciones="getListadoLicitaciones"></listado>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog
      v-model="mostrarVentanaRegistrarNuevaLicitacion"
      :width="!$vuetify.breakpoint.mobile ? '80%' : '90%'">
      <registrar-nueva-licitacion
        v-if="mostrarVentanaRegistrarNuevaLicitacion"
        v-on:cerrar="cerrarVentana">
      </registrar-nueva-licitacion>
    </v-dialog>
    <v-dialog
      v-if="estaLicitacion"
      v-model="mostrarVentanaEditarLicitacion"
      :width="!$vuetify.breakpoint.mobile ? '80%' : '90%'">
      <editar-licitacion
        :licitacionEditar="estaLicitacion"
        v-on:cerrar="cerrarVentana">
      </editar-licitacion>
    </v-dialog>
    <v-dialog
      v-if="estaLicitacion"
      v-model="mostrarVentanaEliminarLicitacion"
      :width="!$vuetify.breakpoint.mobile ? '450' : '90%'">
      <eliminar-licitacion
        :licitacionEliminar="estaLicitacion"
        v-on:cerrar="cerrarVentana">
      </eliminar-licitacion>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="mostrarVentanaCalendario"
      :width="!$vuetify.breakpoint.mobile ? '80%' : '90%'">
      <v-card>
        <v-card-title class="secondary--text">
          Calendario de Eventos de Licitaciones
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrarVentana">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <calendario
          :eventosLicitaciones="getEventosLicitaciones"></calendario>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrarVentana"
            tipo="formCancelar"
            label="Cerrar"
            class="mr-3">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import LICITACIONES from '@/graphql/querys/administracion/licitaciones/licitaciones.gql';
import LICITACIONES_CALENDARIO from '@/graphql/querys/administracion/licitaciones/licitacionesCalendario.gql';
import CustomButton from '@/components/buttons/Button.vue';
import TituloToolBar from '@/components/TituloToolBar.vue';
import RegistrarNuevaLicitacion from '@/components/administracion/licitaciones/Nueva.vue';
import EditarLicitacion from '@/components/administracion/licitaciones/Editar.vue';
import EliminarLicitacion from '@/components/administracion/licitaciones/Eliminar.vue';
import Calendario from '@/components/administracion/licitaciones/calendario/Calendario.vue';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'LicitacionesDefault',
  components: {
    CustomButton,
    TituloToolBar,
    RegistrarNuevaLicitacion,
    EditarLicitacion,
    EliminarLicitacion,
    Calendario,
    ToolBar,
    Listado,
  },
  data() {
    return {
      mostrarVentanaRegistrarNuevaLicitacion: false,
      mostrarVentanaCalendario: false,
      mostrarVentanaEditarLicitacion: false,
      mostrarVentanaEliminarLicitacion: false,
      estaLicitacion: null,
      filtros: {
        ejercicio: new Date().getFullYear(),
        buscarTexto: '',
        tipos: [],
        normatividad: [],
        caracter: [],
        estatus: [],
      },
    };
  },
  apollo: {
    licitaciones: {
      query: LICITACIONES,
    },
    licitacionesCalendario: {
      query: LICITACIONES_CALENDARIO,
    },
  },
  mounted() {
    eventBus.$on('editar-licitacion', (licitacion) => {
      this.estaLicitacion = licitacion;
      this.mostrarVentanaEditarLicitacion = true;
    });
    eventBus.$on('eliminar-licitacion', (licitacion) => {
      this.estaLicitacion = licitacion;
      this.mostrarVentanaEliminarLicitacion = true;
    });
  },
  methods: {
    abrirCalendario() {
      this.mostrarVentanaCalendario = true;
    },
    registrarNuevaLicitacion() {
      this.mostrarVentanaRegistrarNuevaLicitacion = true;
    },
    cerrarVentana() {
      this.mostrarVentanaCalendario = false;
      this.mostrarVentanaRegistrarNuevaLicitacion = false;
      this.mostrarVentanaEditarLicitacion = false;
      this.mostrarVentanaEliminarLicitacion = false;
      this.estaLicitacion = null;
    },
  },
  computed: {
    getLicitacioes() {
      if (!this.licitaciones) return [];
      return this.licitaciones;
    },
    getListadoLicitaciones() {
      if (!this.licitaciones) return [];
      return this.licitaciones
      // Agregar Ejercicio
        .map((licitacion) => ({
          ...licitacion,
          ejercicio: new Date(licitacion.fechaConvocatoria).getFullYear(),
        }))
        .slice()
        .sort((a, b) => new Date(a.fechaConvocatoria) - new Date(b.fechaConvocatoria))
        // Filtrar por Ejercicio
        .filter(({ ejercicio }) => ejercicio === this.filtros.ejercicio)
        // Filtrar por Tipo
        .filter(({ tipo }) => {
          const { tipos } = this.filtros;
          if (this.filtros.tipos.length <= 0) return true;
          return tipos.includes(tipo);
        })
        // Filtrar por Normatividad
        .filter(({ normatividad }) => {
          const tiposNormatividad = this.filtros.normatividad;
          if (this.filtros.normatividad.length <= 0) return true;
          return tiposNormatividad.includes(normatividad);
        })
        // Filtrar por Caracter
        .filter(({ caracter }) => {
          const tiposCaracter = this.filtros.caracter;
          if (this.filtros.caracter.length <= 0) return true;
          return tiposCaracter.includes(caracter);
        })
        // Filtrar por Estatus
        .filter(({ estatus }) => {
          const tiposEstatus = this.filtros.estatus;
          if (this.filtros.estatus.length <= 0) return true;
          return tiposEstatus.includes(estatus);
        })
        // Filtrar por Texto de Busqueda
        .filter((licitacion) => {
          if (!this.filtros.buscarTexto) return licitacion;
          const expt = new RegExp(this.filtros.buscarTexto, 'gi');
          const numero = this.$normalizacionTexto(licitacion.numero);
          const objeto = this.$normalizacionTexto(licitacion.objeto);
          const numeroConvocatoria = this.$normalizacionTexto(licitacion.numeroConvocatoria);
          const estatus = this.$normalizacionTexto(licitacion.estatus);
          return (
            expt.test(numero)
            || expt.test(objeto)
            || expt.test(numeroConvocatoria)
            || expt.test(estatus)
            || expt.test(licitacion.numero)
            || expt.test(licitacion.objeto)
            || expt.test(licitacion.numeroConvocatoria)
            || expt.test(licitacion.estatus)
          );
        });
    },
    getEventosLicitaciones() {
      if (!this.licitacionesCalendario) return [];
      return this.licitacionesCalendario;
    },
  },
};
</script>

<style lang="scss">

</style>
